import { render, staticRenderFns } from "./reports-legend-game-course.vue?vue&type=template&id=130c8dd5&scoped=true"
import script from "./reports-legend-game-course.vue?vue&type=script&lang=js"
export * from "./reports-legend-game-course.vue?vue&type=script&lang=js"
import style0 from "./reports-legend-game-course.vue?vue&type=style&index=0&id=130c8dd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c8dd5",
  null
  
)

export default component.exports